export default __webpack_public_path__ + "static/media/fifa22.c82d997f.png";